/**
 * @generated SignedSource<<574e50111ae1d0470526deceb8d2f915>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IssueComment_issueComment$data = {
  readonly id: string;
  readonly issue: {
    readonly id: string;
  };
  readonly " $fragmentSpreads": FragmentRefs<"IssueCommentEditorBodyFragment" | "IssueCommentEditor_repository" | "IssueCommentViewerCommentRow">;
  readonly " $fragmentType": "IssueComment_issueComment";
};
export type IssueComment_issueComment$key = {
  readonly " $data"?: IssueComment_issueComment$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueComment_issueComment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IssueComment_issueComment",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "IssueCommentViewerCommentRow"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "IssueCommentEditor_repository"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "IssueCommentEditorBodyFragment"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Issue",
      "kind": "LinkedField",
      "name": "issue",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    (v0/*: any*/)
  ],
  "type": "IssueComment",
  "abstractKey": null
};
})();

(node as any).hash = "cfac44fe27e4b723003c1b4fa6371903";

export default node;
